import firebase from "firebase";
import _debug from "debug";
import { USERS_COLLECTION } from "./User";

const debug = _debug("Mediacao:models:FirebaseModel.ts");

export function refAsString(ref: any) {
    if (typeof ref === "string") {
        return ref;
    } else if (ref === null) {
        return "";
    } else {
        return ref.id;
    }
}

function fromRef2String(dados: any) {
    if (dados.creator) {
        try {
            dados.creator = dados.creator.id;
        } catch (e) {
            console.error(e);
        }
    }
    return dados;
}

export interface FirebaseModelData {
    id?: string;
    created_at?: firebase.firestore.Timestamp;
    updated_at?: firebase.firestore.Timestamp;
    creatorRef?: string;
}

export default class FirebaseModel {
    // eslint-disable-next-line
    public get created_at(): Date | undefined {
        if (this.myData.created_at) {
            return this.myData.created_at.toDate();
        }
        return undefined;
    }

    public static fromRef2String(dados: any): any {
        return fromRef2String(dados);
    }

    public static async getById(collection: string, id: string, contrutor: (id: string, data: any, collection?: string) => FirebaseModel = FirebaseModel.modelFromDb) {
        const ref = await firebase
            .firestore()
            .collection(collection)
            .doc(id);
        const document = await ref.get();
        return contrutor(document.id, document.data(), collection);
    }
    protected static modelFromDb(id: string, data: any, collection = ""): FirebaseModel {
        return Object.assign(new FirebaseModel(collection), { id }, data);
    }

    protected myData: FirebaseModelData = {};
    private creatorRef?: string;

    constructor(readonly collection: string, creator?: string) {
        if (creator) {
            this.creatorRef = creator;
        }
    }

    protected augmentData(data: any): any {
        const augumentedData = Object.assign({}, data, {
            // eslint-disable-next-line
            updated_at: firebase.firestore.FieldValue.serverTimestamp(),
        });

        if (!data.created_at) {
            // eslint-disable-next-line
            augumentedData.created_at = firebase.firestore.FieldValue.serverTimestamp();
        }
        if (typeof data.creator === "string") {
            augumentedData.creator = firebase
                .firestore()
                .collection(USERS_COLLECTION)
                .doc(data.creator);
        }
        if (data.creatorRef) {
            augumentedData.creator = firebase
                .firestore()
                .collection(USERS_COLLECTION)
                .doc(data.creatorRef);
            delete augumentedData.creatorRef;
        }
        if (!data.creator) {
            const creatorRef = this.getCreatorRef();
            if (creatorRef) {
                augumentedData.creator = creatorRef;
            }
        } else if (data.id) {
            delete augumentedData.creator;
        }

        return augumentedData;
    }

    protected async _add(data: any, collection: string = this.collection): Promise<unknown> {
        debug(`Criando novo item na coleção ${collection}:`, data);
        const augumentedData = this.augmentData(data);
        const theRef = await firebase
            .firestore()
            .collection(collection)
            .add(augumentedData);

        const savedData = await theRef.get();
        const document: unknown = Object.assign({ id: savedData.id }, savedData.data());
        return document;
    }

    protected async update(data: any): Promise<unknown> {
        if (!this.creatorRef && data.creatorRef) {
            this.creatorRef = data.creatorRef;
        }
        if (!data.id) {
            return this._add(data);
        } else {
            const augumentedData = this.augmentData(data);
            delete augumentedData.id;
            for (const key of Object.keys(augumentedData)) {
                if (augumentedData[key] === undefined) {
                    delete augumentedData[key];
                }
            }
            const theRef = firebase
                .firestore()
                .collection(this.collection)
                .doc(data.id);
            debug(`Vai fazer update em ${this.collection}`, augumentedData);
            await theRef.update(augumentedData);
            const savedData = await theRef.get();
            const document: unknown = Object.assign({ id: savedData.id }, savedData.data());
            return document;
        }
    }

    protected getCollection() {
        return firebase.firestore().collection(this.collection);
    }

    private getCreatorRef() {
        if (this.creatorRef) {
            return firebase
                .firestore()
                .collection("users")
                .doc(this.creatorRef);
        } else {
            return null;
        }
    }
}
